<template lang="pug">
section
  v-card(:flat='flat')
    v-toolbar(flat color='white')
      h2(class='title font-weight-medium') Пользователи
      v-spacer
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :hide-actions='true'
    )
      template(slot='items' slot-scope='props')
        tr(@click='onEdit(props.item.id)' :class='{ "with-pointer": editable }')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Имя пользователя') {{ props.item.name }}
          td(data-label='Email') {{ props.item.email }}
          td(data-label='Телефон' class='wrapless') {{ props.item.phone | phone }}
          td(data-label='Статус') {{ props.item.status }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Имя пользователя',
        align: 'left',
        value: 'name',
        width: '25%',
        sortable: false
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
        width: '25%',
        sortable: false
      },
      {
        text: 'Телефон',
        align: 'left',
        value: 'phone',
        width: '25%',
        sortable: false
      },
      {
        text: 'Статус',
        align: 'left',
        value: 'status',
        width: '25%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  props: {
    isLoading: Boolean,
    list: Array,
    flat: Boolean,
    editable: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onDelete(id) {
      this.$emit('delete', id)
    },

    onEdit(id) {
      this.$emit('edit', id)
    }
  }
}
</script>
